// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DV4D","col":"styles_col__1LSLL"};